// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"GIwME","breadcrumb":"cPaqC","separator":"yie40","primary":"uetVE","label":"vszGt","clickable":"omV6x","icon":"ZDMzC"};